import React from "react";
import {BarChart, MapChart, SunburstChart, Table} from "../chart";
import {Filters} from "./shared/Filters/Filters";
import {useFetchData} from "./shared/useFetchData";

const ZlobkiDashboard = () => {
    const [initData, data, filters, activeFilters, setFilters] = useFetchData('REJESTR_ZLOBKOW', true);

    return (
        <div className="container">
            <div className="title-container">
                <h2 className={'title'}>Rejestr żłobków i klubów dziecięcych</h2>
            </div>
            <Filters data={filters} setFilters={setFilters}/>
            <div className="visualization-container">
                <BarChart data={data}
                          activeFilters={activeFilters}
                          groupBy={'organization'}
                          groupBy2={'operatorname'}
                          title={'Liczba miejsc'}
                          value={'businessPlacetotalSpots'}
                          wide/>
            </div>
            <div className="visualization-container">
                <BarChart data={data}
                          activeFilters={activeFilters}
                          groupBy={'organization'}
                          groupBy2={'operatorname'}
                          title={'Liczba zapisanych dzieci'}
                          value={'businessPlacetakenSpots'}
                          wide/>
            </div>
            <div className="visualization-container">
                <MapChart data={initData}
                          filters={filters}
                          activeFilters={activeFilters}
                          groupBy={'organization'}
                          value={'value'}
                          featureClick={setFilters}/>
                <BarChart data={data}
                          groupBy={'organization'}
                          value={'value'}
                          title={'Liczba instytucji'}
                          layout={'horizontal'}/>
            </div>
            <div className="visualization-container">
                <SunburstChart data={data}
                               title={'Liczba miejsc'}
                               groupBy={'organization'}
                               childrenGroupBy={'businessPlaceinstitutionType'}
                               groupByTitle={'Gmina'}
                               childrenGroupByTitle={'Typ instytucji'}
                               value={'businessPlacetotalSpots'}/>
                <Table data={data}
                       filters={filters}
                       columns={['operatorname', 'organization', 'businessPlaceinstitutionType']}
                       columnNames={{
                           'operatorname': 'Nazwa'
                       }}/>
            </div>
        </div>
    )
}

export {ZlobkiDashboard as default}